//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PNFLRINEC",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6:'',
      },
      form1:{
        value1:'0'
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "<150" },
        { value: "4", name: "≥150" }
      ],
      dataList1: [
        { value: "0", name: "<15" },
        { value: "1", name: "15~25" },
        { value: "2", name: ">25" },
      ],
      dataList2: [
        { value: "0", name: ">135" },
        { value: "1", name: "110~135" },
        { value: "2", name: "<110" },
      ],
      dataList3: [
        { value: "0", name: "≥135" },
        { value: "2", name: "<135" },
      ],
      dataList4: [
        { value: "0", name: "≤141" },
        { value: "2", name: ">141" },
      ],
      dataList5: [
        { value: "0", name: "≤10" },
        { value: "1", name: ">10" },
      ],
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PNFLRINEC.vue